import ModalModule from './modal.module'

export default ModalModule
